'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import { useUi } from '@weareconceptstudio/core';
import { showFulfillmentRequiredPopup } from '@/helpers/fulfillmentGuard';
import { LOCALES } from '@/constants';

const getIsShopPage = (pathname) => {
	const pathSegments = pathname.split('/').filter(Boolean);
	const normalizedSegments = LOCALES.includes(pathSegments[0]) ? pathSegments.slice(1) : pathSegments;
	return normalizedSegments[0] === 'menu';
};

export const useShopFulfillmentEntryPrompt = ({
	enabled,
	hasFulfillmentSelection,
	initialTab = 'delivery',
}) => {
	const pathname = usePathname();
	const { openPopup, closePopup } = useUi();
	const promptedRef = useRef(false);
	const isShopPage = getIsShopPage(pathname);

	useEffect(() => {
		if (!isShopPage) promptedRef.current = false;
	}, [isShopPage]);

	useEffect(() => {
		if (!enabled || !isShopPage || hasFulfillmentSelection || promptedRef.current) return;

		promptedRef.current = true;
		showFulfillmentRequiredPopup(openPopup, closePopup, {
			initialTab,
			redirectAfterConfirm: false,
		});
	}, [closePopup, enabled, hasFulfillmentSelection, initialTab, isShopPage, openPopup]);
};
